import { Component } from '@angular/core';

interface CellRendererParams {
  value: string;
}

@Component({
  selector: 'app-request-id-cell-renderer',
  template: '<span>{{ params.value }}</span>'
})
export class RequestIdCellRendererComponent {
  public params: CellRendererParams;

  public agInit(params: CellRendererParams): void {
    this.params = params;
  }
}
